import ModusServiceModel from "../ModusServiceModel";
import ResultEventModel from "./ResultEventModel";
import DepthReferenceModel from "./DepthReferenceModel";
import ResultNutrientCollection from "@/collections/modus/ResultNutrientCollection";
import ResultNutrientRecommendationCollection from "@/collections/modus/ResultNutrientRecommendationCollection";
import LaboratoryTestPackageModel from "./LaboratoryTestPackageModel";

export default class ResultEventSampleModel extends ModusServiceModel {
  modelName() {
    return 'result-event-samples';
  }
  icon() {
    return 'vial';
  }
  defaults() {
    return {
      id: null,
      result_event_id: null,
      result_event: null,
      depth_reference_id: null,
      depth_reference: null,
      laboratory_test_package_id: null,
      laboratory_test_package: null,
      container_id: null,
      group_ref: null,
      number: null,
      comments: null,
      latitude: null,
      longtitude: null,
      wkt_geometry: null,
      soil: null,
      water: null,
      tissue: null,
      nematode: null,
      residue: null,
      record_created_at: null,
      record_updated_at: null,
      record_overwritten: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      result_nutrients: {},
      result_nutrient_recommendations: {}
    }
  }
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      result_event_id: (val) => (this.nullStringMutator(val)),
      depth_reference_id: (val) => (this.nullStringMutator(val)),
      laboratory_test_package_id: (val) => (this.nullStringMutator(val)),
      container_id: (val) => (this.nullStringMutator(val)),
      group_ref: (val) => (this.nullStringMutator(val)),
      number: (val) => (this.nullStringMutator(val)),
      comments: (val) => (this.nullStringMutator(val)),
      latitude: (val) => (this.nullStringMutator(val)),
      longtitude: (val) => (this.nullStringMutator(val)),
      wkt_geometry: (val) => (this.nullStringMutator(val)),
      soil: Boolean,
      water: Boolean,
      tissue: Boolean,
      nematode: Boolean,
      residue: Boolean,
      record_created_at: (val) => (this.nullStringMutator(val)),
      record_updated_at: (val) => (this.nullStringMutator(val)),
      record_overwritten: Boolean,
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val)),
    }
  }
  validation() {
    return {}
  }

  getTypeLabel() {
    if(this.soil) {
      return 'Soil';
    } else if(this.water) {
      return 'Water';
    } else if(this.tissue) {
      return 'Tissue';
    } else if(this.nematode) {
      return 'Nematode';
    } else if(this.residue) {
      return 'Residue';
    }
    return 'N/A';
  }
  getResultEvent() {
    return this.getRelatedModel(ResultEventModel, 'result_event');
  }
  getDepthReference() {
    return this.getRelatedModel(DepthReferenceModel, 'depth_reference');
  }
  getLaboratoryTestPackage() {
    return this.getRelatedModel(LaboratoryTestPackageModel, 'laboratory_test_package');
  }
  getResultNutrients() {
    return this.getRelatedCollection(new ResultNutrientCollection(), 'result_nutrients');
  }
  getResultNutrientRecommendations() {
    return this.getRelatedCollection(new ResultNutrientRecommendationCollection(), 'result_nutrient_recommendations');
  }

}
